<template>
  <div></div>
</template>
<script>

import { Toast } from 'vant';
	
export default {

  data() {
    return {
		code:'',
		id:'',
		file:''
     
    };
  },mounted() {
	
	this.sank()
	
	this.sandMate()

  },methods:{
	  sank(){
		  var url = window.location.href ;           
		  
		      var dz_url = url.split('#')[0];               
		  
		      var cs = dz_url.split('?')[1];             
		  
		      var cs_arr = cs.split('&');             
		  
		      var cs={};
		  
		      for(var i=0;i<cs_arr.length;i++){       
		  
		        cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
		  
		      }

		  this.code = cs.code;   
	
		  
		
	  },
	  stone(id){
		  
		 this.$axios({
		   method: "post",
		   url: "stores/info",
		   data: {},  
		 }).then((res)=>{
		     let data=res.data;
		     
		     if(data.code==200){
		     	data.data.store_info.token=id
		     	localStorage.setItem('user',JSON.stringify(data.data.store_info))
		     	this.$router.push({ path: "/" });
		     	
		     
		     }
		  })
		  
	
	
	  },
	 sandMate(){
	 	this.$axios({
	 	  method: "post",
	 	  url: "stores/login",
	 	  data: {code:this.code},  
	 	}).then((res) => { 
	 		
	 		let data=res.data;
	 		if(data.code==200){
	 		 
			localStorage.setItem('user',JSON.stringify(data.data))
		
			this.stone(data.data.token)	
			
		
			
			
			  

			
			
			
	 		
	 		
	 		
	 	
	 		
	 		}
	 	 
	 	});
	
	 }
  }
};
</script>
